import React from 'react';
import Box from '@mui/material/Box';
import { styled } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import LauncherButton from 'modules/connect-card-widget/components/launchers/LauncherButton';
import LauncherText from 'modules/connect-card-widget/components/launchers/LauncherText';
import noop from 'lodash/noop';
import classnames from 'classnames';
import {
  LauncherTextWrapper,
  LauncherButtonWrapper,
} from 'modules/connect-card-widget/containers/embed-widget/styles';

const Fab = styled(Box)`
  position: absolute;
  width: 100%;
  bottom: 10px;
  &.left {
    left: 0;
  }
  &.right {
    right: 0;
  }
`;

const ChatBubblePreview = ({ chat, color }) => {
  const { enabled, text, subtitle, position = 'right' } = chat;
  return (
    <>
      {enabled && (
        <Fab className={position}>
          <LauncherTextWrapper
            sx={{
              position: 'absolute',
            }}
            className={classnames({
              left: position === 'left',
              closed: false,
            })}
          >
            <LauncherText data={chat} onClick={noop} />
          </LauncherTextWrapper>
          <LauncherButtonWrapper
            sx={{
              position: 'absolute',
            }}
            className={classnames({
              left: position === 'left',
              position: 'absolute',
            })}
          >
            <LauncherButton onClick={noop} />
          </LauncherButtonWrapper>
        </Fab>
      )}
    </>
  );
};

export default ChatBubblePreview;
